import { SearchSettingsModel } from '@syncfusion/ej2-react-treegrid';
import { ToolbarType } from '@parspec/pixel';

import { CellClassRules, ColDef, RowRenderer, SuppressKeyboardEventParams } from '@ag-grid-community/core';

import { suppresskeyboardEventForEnter } from '../shared/utils';

export const getStats = (data: any) => {
    if (data?.data) {
        const { product, hidden_product, manufacturer } = data.data;
        return [
            {
                title: 'Manufacturer(s)',
                count: manufacturer
            },
            {
                title: 'Products',
                count: product
            },
            {
                title: 'Hidden',
                count: hidden_product
            }
        ];
    }
    return [];
};

export const toolBarOptions = ['createSection', 'delete', 'search', 'hide', 'selectedItems', 'duplicate', 'move', 'createKit', 'highlight', 'bulkEdit'];
export const BULK_EDIT_OPTIONS = ['qty', 'qtyPer', 'specification', 'manufacturer'];

export const getTableProps = (args: any) => {
    const toolBarItems: ToolbarType = ['add', 'delete', 'search', 'hide', 'duplicate', 'selectedItems', 'move', 'createKit'];
    const searchSettings: SearchSettingsModel = {
        fields: ['category', 'qty', 'description', 'model_number', 'manufacturer'],
        hierarchyMode: 'Both'
    };

    return {
        toolBarOptions: toolBarItems,
        allowPaging: false,
        allowFiltering: false,
        selectionSettings: {
            checkboxOnly: true,
            persistSelection: true
        },
        ...args,
        searchSettings
    };
};

export const defaultColDef: ColDef = {
    sortable: false,
    menuTabs: [],
    resizable: true,
    suppressFillHandle: true,
    suppressKeyboardEvent: (params: SuppressKeyboardEventParams) => {
        if (params.event.key === 'Enter') return suppresskeyboardEventForEnter(params);
        return false;
    }
};

export const getAutoGroupColumnDef = (isHoverCellClassRules: CellClassRules): ColDef => ({
    headerName: '',
    width: 110,
    showRowGroup: true,
    pinned: 'left',
    suppressMovable: true,
    resizable: false,
    cellRendererParams: {
        suppressCount: true,
        checkbox: true,
        innerRenderer: (params: RowRenderer) => ''
    },
    cellClassRules: { ...isHoverCellClassRules },
    headerCheckboxSelection: true
});
